import React from 'react';

import { EmptyState } from './components/empty-state/EmptyState';

export const EarningsRecap = () => {
  return <EmptyState />;
};
